import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { BackgroundGradient, Loader, SafeAreaView, Storage, Alert } from '../../components';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';
import UserState from '../../src/contexts/UserState';
import { app, url } from '../../constants/DevProd';
import { WebView } from 'react-native-webview';

const DisputePayment = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(true);
  const [rtJWT, setRtJWT] = React.useState(null);
  const [fees, setFees] = React.useState({});
  const [alertOptions, setAlertOptions] = React.useState({});

  const linkTo = useLinkTo();

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/dispute/${route.params.agreementId}/questions`);
    }
  }

  React.useEffect(() => {
    if (Platform.OS === 'web') {
      window.addEventListener("message", (event) => {
        if (event.origin === "https://app.dev.renovationtrust.com" || event.origin === "https://app.renovationtrust.com" || event.origin === "https://dev.renovationtrust.com" || event.origin === "https://renovationtrust.com") {
        // if (event.origin === "https://dev.renovationtrust.com" || event.origin === "https://renovationtrust.com") {
          console.log('message: ', event);
          onMessage(event.data);
        }
      }, false);
    }
    getRtJwt();
    getFees();
  }, []);

  const getRtJwt = async () => {
    setRtJWT(await Storage.getItem('rtJWT'));
  }

  const getFees = async () => {
    const fees = await Storage.getItem('rtDisputeFees');
    console.log('getFees: ', fees, JSON.parse(fees));
    setFees(JSON.parse(fees));
  }

  const onNativeMessage = (event) => {
    const data = JSON.parse(event.nativeEvent.data)
    onMessage(data);
  }
  const onMessage = (data) => {
    if (data) {
      if (data.loading !== undefined) {
        setLoading(data.loading);
      }
      switch (data.action) {
        case 'complete':
          setAlertOptions({
            visible: true,
            title: 'Success',
            message: "Please allow us a few minutes to finish processing your dispute. We'll notify you as soon as we've finished.",
            buttons: [
              {
                text: 'OK',
                onPress: () => linkTo('/projects'),
              },
            ]
          })
          break;
      }
    }
  }

  const renderPayment = () => {
    if (Platform.OS === 'web') {
      return (
        <iframe
          allow='payment *'
          src={`${app.base}credit_card.php?jwt=${rtJWT}&freshdesk_id=${route.params.freshDeskId}`}
          // src={`${url.base}credit_card.php?jwt=${rtJWT}&freshdesk_id=${route.params.freshDeskId}`}
          frameBorder='0'
          width='100%'
          height='200px'
        />
      )
    }
    return (
      <WebView
        style={{ height: 200, width: '100%', backgroundColor: 'transparent' }}
        originWhitelist={['*']}
        javaScriptEnabled
        onMessage={onNativeMessage}
        // source={{
        //   html: `<html>
        //           <head>
        //             <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">
        //           </head>
        //           <body style='margin: 0'>
        //             <iframe
        //               allow='payment *'
        //               src='${app.base}credit_card.php?jwt=${rtJWT}&freshdesk_id=${route.params.freshDeskId}'
        //               frameborder='0'
        //               width='100%'
        //               height='200px'
        //             />
        //           </body>
        //         </html>`
        // }}
        source={{
          uri: `${app.base}credit_card.php?jwt=${rtJWT}&freshdesk_id=${route.params.freshDeskId}`
          // uri: `${url.base}credit_card.php?jwt=${rtJWT}&freshdesk_id=${route.params.freshDeskId}`
        }}
      />
    )
  }

  const amountBreakdown = () => {
    return (
      <View style={styles.amountBreakdownContainer}>
        <View style={[CS.rowContainer, styles.amountContainer]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Dispute Cost</Text>
          <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{fees.sub_total}</Text>
        </View>
        <View style={[CS.rowContainer, styles.amountContainer]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Tax</Text>
          <Text style={[CS.smallText, CS.lightText, CS.rightText, styles.amount]}>{fees.tax}</Text>
        </View>
        <View style={styles.separator}></View>
        <View style={[CS.rowContainer, styles.amountContainer, { marginBottom: 0 }]}>
          <Text style={[CS.mediumText, CS.boldText, CS.lightBlueText]}>Total Amount</Text>
          <Text style={[CS.mediumText, CS.boldText, CS.lightText, CS.rightText, styles.amount]}>{fees.total}</Text>
        </View>
      </View>
    )
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <View style={CS.innerContainer}>
        <View style={styles.titleContainer}>
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>Dispute Payment</Text>
          <TouchableOpacity onPress={goBack} style={styles.backArrow}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
        </View>
        {amountBreakdown()}
        {renderPayment()}
      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  titleContainer: {
    marginVertical: 20,
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  backArrow: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
  amountBreakdownContainer: {
    marginVertical: 20,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Colors.textInputBackground,
    width: '100%',
  },
  amountContainer: {
    // flex: 1,
    marginBottom: 5,
  },
  amount: {
    flex: 1,
  },
  separator: {
    borderWidth: 1,
    borderColor: Colors.lightGrey,
    marginVertical: 8,
  },
});

export default DisputePayment;